'use client';

import Script from 'next/script';
import { GOOGLE_ADS_ID } from '@/lib/conversion';

// 구글·유튜브 광고 태그 (전환 측정·광고 클릭 연결). 환경 변수 NEXT_PUBLIC_GOOGLE_ADS_ID 가 있을 때만 불러온다
export default function GoogleAdsTag() {
  if (!/^AW-\d+$/.test(GOOGLE_ADS_ID)) return null;
  return (
    <>
      <Script data-component-id="src/components/common/GoogleAdsTag.tsx:11:6" data-component-path="src/components/common/GoogleAdsTag.tsx" data-component-line="11" data-component-end-line="11" data-component-file="GoogleAdsTag.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%7D" src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`} strategy="afterInteractive" />
      <Script data-component-id="src/components/common/GoogleAdsTag.tsx:12:6" data-component-path="src/components/common/GoogleAdsTag.tsx" data-component-line="12" data-component-end-line="14" data-component-file="GoogleAdsTag.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%2C%22id%22%3A%22google-ads-init%22%7D" id="google-ads-init" strategy="afterInteractive">
        {`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}window.gtag=gtag;gtag('js',new Date());gtag('config','${GOOGLE_ADS_ID}');`}
      </Script>
    </>
  );
}
